let calendarIds = {
  'London': 8,
  'Birmingham': 17,
  'Leeds': 21,
  "Liverpool": 22,
  'Singapore': 5,
  'Zürich': 23,
  'Manchester':20
};

$('.showroom-carousel__tabs .tab:first-child').addClass('active')

$('.showroom-carousel__tabs .tab a').on('click', function (e) {
    e.preventDefault();
    if (!$(this).closest('.tab').hasClass('active')) {
        $('.showroom-carousel__tabs .tab').removeClass('active')
        $(this).closest('.tab').addClass('active')
        var block = $(this).attr('href');
        $('.showroom-carousel__slides .showroom-item').hide()
        $(block).fadeIn()
    }
})

let onlyShowFourWeeks = $('#onlyShowFourWeeks').val();
if (onlyShowFourWeeks === 'true') onlyShowFourWeeks = true;
if (onlyShowFourWeeks === 'false') onlyShowFourWeeks = false;
if (window.location.href.includes('phone')) onlyShowFourWeeks = false;

window.services = [];
window.serviceData = {};
window.dataLayer = window.dataLayer || [];
window._loq = window._loq || [];

// Helper function to translate service titles
function translateServiceTitle(text) {
    if (window.shopLocale && (window.shopLocale === 'de' || window.shopLocale.startsWith('de-')) && window.translations && window.translations.bookingTool && window.translations.bookingTool.serviceTypes) {
        if (text.includes('I would like to purchase') && text.includes('60 min')) {
            return window.translations.bookingTool.serviceTypes.purchase60;
        }
        else if (text.includes('I would like to browse') && text.includes('30 min')) {
            return window.translations.bookingTool.serviceTypes.browse30;
        }
    }
    return text;
}

// Helper function to translate appointment type names
function translateAppointmentType(text) {
    if (window.shopLocale && (window.shopLocale === 'de' || window.shopLocale.startsWith('de-')) && window.translations && window.translations.bookingTool && window.translations.bookingTool.appointmentTypes) {
        if (text === 'Purchase Appointment') {
            return window.translations.bookingTool.appointmentTypes.purchaseAppointment;
        }
        else if (text === 'Browsing Appointment') {
            return window.translations.bookingTool.appointmentTypes.browsingAppointment;
        }
        else if (text === 'Measurement Appointment') {
            return window.translations.bookingTool.appointmentTypes.measurementAppointment;
        }
        else if (text === 'Delivery Appointment') {
            return window.translations.bookingTool.appointmentTypes.deliveryAppointment;
        }
    }
    return text;
}

const apiHost = 'https://book-new.editsuits.com';

$.getJSON("https://api.ipify.org?format=json", function (data) {

    $("#customerIP").val(data.ip);
});

function decodeHtmlEntitiesDeep(input) {
    if (!input || typeof input !== 'string') return input;

    let decoded = input;
    for (let i = 0; i < 3; i++) {
        const next = $('<textarea/>').html(decoded).text();
        if (next === decoded) break;
        decoded = next;
    }

    return decoded;
}

function trackEspixel(event, payload = {}) {
    try {
        if (window.espixel && typeof window.espixel.track === 'function') {
            window.espixel.track(event, payload);
        }
    } catch (error) {
        console.error('An error occurred in trackEspixel:', error);
    }
}

function identifyEspixelCustomer() {
    try {
        const email = ($('input[name="email"]').val() || '').trim();
        if (!email) return false;

        const name = [
            $('input[name="first-name"]').val(),
            $('input[name="last-name"]').val()
        ].filter(Boolean).join(' ').trim();

        if (window.__espixelLastEmail === email && window.__espixelLastName === name) {
            return false;
        }

        window.__espixelLastEmail = email;
        window.__espixelLastName = name;

        if (window.espixel && typeof window.espixel.identify === 'function') {
            window.espixel.identify(email, name);
        }
    } catch (error) {
        console.error('An error occurred in identifyEspixelCustomer:', error);
    }
}

function normalizeAcquisitionChannelOptions() {
    const $acquisitionChannel = $('#acquisition_channel');
    if (!$acquisitionChannel.length) return;

    $acquisitionChannel.find('option').each(function () {
        const currentText = $(this).text();
        const currentValue = $(this).attr('value');
        const normalizedText = decodeHtmlEntitiesDeep(currentText);
        const normalizedValue = decodeHtmlEntitiesDeep(currentValue);

        if (normalizedText !== currentText) {
            $(this).text(normalizedText);
        }
        if (normalizedValue !== currentValue) {
            $(this).attr('value', normalizedValue);
        }
    });
}


function rebuildAcquisitionChannels() {

 let country = 'GB';
 if (window.location.href.includes('en-sg')) country = 'SG';

 $.getJSON("https://api.v3.editsuits.com/customer/acquisition_channels/" + country, function (data) {

   if (data && data.channels) {

        // Translation map for acquisition channels
        const acquisitionChannelTranslations = {
            'Facebook ad': window.translations.bookingTool?.acquisitionChannel?.options?.facebookAd || 'Facebook ad',
            'Instagram ad': window.translations.bookingTool?.acquisitionChannel?.options?.instagramAd || 'Instagram ad',
            'Instagram / Facebook ad': window.translations.bookingTool?.acquisitionChannel?.options?.instagramFacebookAd || 'Instagram / Facebook ad',
            'LinkedIn': window.translations.bookingTool?.acquisitionChannel?.options?.linkedIn || 'LinkedIn',
            'From a friend / referral': window.translations.bookingTool?.acquisitionChannel?.options?.friendReferral || 'From a friend / referral',
            'Google Search': window.translations.bookingTool?.acquisitionChannel?.options?.googleSearch || 'Google Search',
            'Google search': window.translations.bookingTool?.acquisitionChannel?.options?.googleSearch || 'Google search',
            'Google ad': window.translations.bookingTool?.acquisitionChannel?.options?.googleAd || 'Google ad',
            'ChatGPT': window.translations.bookingTool?.acquisitionChannel?.options?.chatgpt || 'ChatGPT',
            'Birmingham - Mailbox Store': window.translations.bookingTool?.acquisitionChannel?.options?.birminghamMailboxStore || 'Birmingham - Mailbox Store',
            'London - Bond Street Store': window.translations.bookingTool?.acquisitionChannel?.options?.londonBondStreetStore || 'London - Bond Street Store',
            'London - City Store': window.translations.bookingTool?.acquisitionChannel?.options?.londonCityStore || 'London - City Store',
            'Leeds Store': window.translations.bookingTool?.acquisitionChannel?.options?.leedsStore || 'Leeds Store',
            'Manchester Store': window.translations.bookingTool?.acquisitionChannel?.options?.manchesterStore || 'Manchester Store',
            'National Wedding Show': window.translations.bookingTool?.acquisitionChannel?.options?.nationalWeddingShow || 'National Wedding Show',
            'Wedding show': window.translations.bookingTool?.acquisitionChannel?.options?.weddingShow || 'Wedding show',
            'Employee offer': window.translations.bookingTool?.acquisitionChannel?.options?.employeeOffer || 'Employee offer',
            'Employee offer / from my company': window.translations.bookingTool?.acquisitionChannel?.options?.employeeOffer || 'Employee offer / from my company',
            'Article (magazine/newspaper/online)': window.translations.bookingTool?.acquisitionChannel?.options?.article || 'Article (magazine/newspaper/online)',
            'Article (magazine / newspaper / online)': window.translations.bookingTool?.acquisitionChannel?.options?.article || 'Article (magazine / newspaper / online)',
            "I'm an existing customer": window.translations.bookingTool?.acquisitionChannel?.options?.existingCustomer || "I'm an existing customer",
            "I am an existing customer": window.translations.bookingTool?.acquisitionChannel?.options?.existingCustomer || "I am an existing customer",
            'GBP 100 Voucher': window.translations.bookingTool?.acquisitionChannel?.options?.voucher100 || 'GBP 100 Voucher',
            '£100 refer a friend voucher': window.translations.bookingTool?.acquisitionChannel?.options?.voucher100 || '£100 refer a friend voucher',
            'Flyer / mailing': window.translations.bookingTool?.acquisitionChannel?.options?.flyerMailing || 'Flyer / mailing',
            'Virgin Experience': window.translations.bookingTool?.acquisitionChannel?.options?.virginExperience || 'Virgin Experience',
            'I saw one of your stores': window.translations.bookingTool?.acquisitionChannel?.options?.sawStore || 'I saw one of your stores',
            'Other': window.translations.bookingTool?.acquisitionChannel?.options?.other || 'Other'
        };

        $('#acquisition_channel').empty();
        $('#acquisition_channel').append(
            $('<option>', {value: '', text: ''})
        );
        $.each(data.channels, function(index, channel) {
            // API responses may contain HTML entities (e.g. I&#39;m), so decode before rendering/matching.
            const decodedChannelName = decodeHtmlEntitiesDeep(channel.name || '');
            const normalizedChannelName = decodedChannelName || channel.name || '';
            // Use translated text if available, otherwise use normalized channel name
            const translatedText = acquisitionChannelTranslations[normalizedChannelName]
                || acquisitionChannelTranslations[channel.name]
                || normalizedChannelName;
            const normalizedTranslatedText = decodeHtmlEntitiesDeep(translatedText);
            $('#acquisition_channel').append(
                $('<option>', {
                    value: decodeHtmlEntitiesDeep(normalizedChannelName),
                    text: normalizedTranslatedText
                })
            );
        });

normalizeAcquisitionChannelOptions();

$('#acquisition_channel').trigger('change.select2');


   }


});


    
}

rebuildAcquisitionChannels();


function sendLuckyOrangeEvent(eventName) {

    window._loq.push(["tag", eventName])
}

function resolveAppointmentType(serviceTitle) {
    let appointmentType = '';
    if (serviceTitle.includes('Purchase')) appointmentType = 'purchase';
    if (serviceTitle.includes('Browsing')) appointmentType = 'browsing';
    if (serviceTitle.includes('Virtual')) appointmentType = 'virtual';
    if (serviceTitle.includes('Delivery')) appointmentType = 'delivery';
    return appointmentType;
}

function updateSelectedSalesRep() {

          var selectedOption = $('#salesPerson').find('option:selected');
  
          var salesRepName = selectedOption.text();
          var salesRepImg = selectedOption.data('img-url');
      
        $('.salesRepSelectorSelected').html(`<strong style="padding-right: 50px">${window.bookingTranslations.form.tailoringAdvisor}</strong> <span class="salesPersonOptionSelected"> <img src="${salesRepImg}"/> <b>${salesRepName}</b></span> `);
  
  
}

function rescheduleAlignBookingTool() {

    var $item = $('.booking-grid__item');
    
    if ($item.length) {
        // Calculate the offset to center the element in the middle of the screen
        var itemOffset = $item.offset().top;
        var windowHeight = $(window).height();
        var scrollPosition = itemOffset - (windowHeight / 2) + ($item.outerHeight() / 2);
        
        // Animate the scroll to center the element
        $('html, body').animate({
            scrollTop: scrollPosition
        }, 1000); // You can adjust the duration (1000ms = 1 second)
    }

  
}

function alignBookingTool() {
    let booking = document.querySelector('#aligner');
    $(booking).get(0).scrollIntoView({ block: "start", behavior: "smooth" });
}

var AOS_TOKEN_PREFIX = 'aos_';
var AOS_PREFILL_ENDPOINT = 'https://api.apparel-os.com/booking-prefill/';

function isAosToken(token) {
    return typeof token === 'string' && token.indexOf(AOS_TOKEN_PREFIX) === 0;
}

// Shared pre-fill used by the legacy order-tool, dropped-booking and AOS lookups.
// Accepts either a flat payload or one wrapped in `data`.
// Returns true when first name, last name and phone are all present.
function applyBookingPrefill(payload) {
    var data = (payload && payload.data) ? payload.data : (payload || {});

    var phone = (data.phone === null || data.phone === undefined) ? '' : String(data.phone).trim().replace(' ', '');
    var firstName = (data.first_name === null || data.first_name === undefined) ? '' : data.first_name;
    var lastName = (data.last_name === null || data.last_name === undefined) ? '' : data.last_name;
    var email = (data.email === null || data.email === undefined) ? '' : data.email;

    clearAppointmentData();
    $('input[name="first-name"]').val(firstName).change();
    $('input[name="last-name"]').val(lastName).change();
    $('input[name="email"]').val(email).change();
    $('#phone_formatted').val(phone).change();

    var phoneEl = document.querySelector('#phone');
    if (phoneEl && window.intlTelInputGlobals) {
        var iti = window.intlTelInputGlobals.getInstance(phoneEl);
        if (iti) {
            iti.setNumber(phone);
        }
    }
    $('#phone').change();

    return firstName.length !== 0 && lastName.length !== 0 && phone.length !== 0;
}

// Delivery pages jump straight to step 3 once the customer is fully identified.
function advanceDeliveryStepIfApplicable() {
    if (window.location.pathname.includes('delivery') || window.location.pathname.includes('deliveries')) {
        $('.service_group').hide();
        $('.service_group').first().find('li').click();
        $('.booking-page__steps').hide();
        $('#step3 .back').hide();
        $('#step3').fadeIn();
    }
}

function prefillFromAosToken(token) {
    rescheduleAlignBookingTool();
    // Deliberately NOT setting #customer_token: AOS tokens are not understood by
    // the legacy booking backend, so it must be submitted empty.
    $.ajax({
        url: AOS_PREFILL_ENDPOINT + encodeURIComponent(token),
        success: function (result) {
            if (!applyBookingPrefill(result)) {
                return true;
            }
            advanceDeliveryStepIfApplicable();
        },
        error: function (error) {
            // Invalid or expired token: leave the form blank for manual entry.
        }
    });
}

function prefillTokenData() {

    let id = urlParams.get('token')
    let orderToken = urlParams.get('order_token');
    let droppedToken = '';

    if (id && id.length > 15) {
      droppedToken = id;
      id = null;
    }

    const salesPersonId = urlParams.get('book_with');

    if (salesPersonId) {

       $.ajax({
            url: 'https://api.v3.editsuits.com/store/salesPersonLocations/' + salesPersonId,
            success: function (result) {

                if (result.status === 'success') {

                  $('#salesPersonName').val(result.user.name);
                  for (let calendar of result.data) {

                     let city = '';
            let calendarId = calendar.id;
            $('.tab[calendar_id="' + calendarId + '"] a').click();
            if (calendar.name.includes('London')) city = 'London';
            if (calendar.name.includes('Birmingham')) city = 'Birmingham';
            if (calendar.name.includes('Manchester')) city = 'Manchester';
            if (calendar.name.includes('Leeds')) city = 'Leeds';
            if (calendar.name.includes('Liverpool')) city = 'Liverpool';
            if (calendar.name.includes('Singapore')) city = 'Singapore';
             if (calendar.name.includes('Zurich') || calendar.name.includes('Zürich')) city = 'Zürich';
            if (calendar.name.includes('Virtual')) city = 'Video appointment - UK';
         
            $('select#salesLocation').val(city).trigger('change');
          
            $('.acquisitionChannelHolder').hide();
                    
                  }

                  
                }

              
            }
            });



      
    }

    // An AOS token may arrive as ?token= instead of ?order_token=; the length
    // heuristic above would otherwise route it to the dropped-booking endpoint.
    if (isAosToken(droppedToken)) {
        orderToken = droppedToken;
        droppedToken = '';
    }
    if (isAosToken(id)) {
        orderToken = id;
        id = null;
    }

    if (id != null) {
        rescheduleAlignBookingTool();
        $('.booking-page__steps').hide()
        $('#step6').fadeIn()
        $('#basicConfirmation').hide();
        $('#basicTitle').hide();
        $('#tokenConfirmation').show();
        $('#tokenTitle').show()
        rescheduleAppointment(id);
    }

    if (orderToken != null) {

        if (isAosToken(orderToken)) {
            prefillFromAosToken(orderToken);
        } else {
            rescheduleAlignBookingTool();
            $('#customer_token').val(orderToken);
            $.ajax({
                url: 'https://api.v3.editsuits.com/store/booking/delivery/' + orderToken,
                success: function (result) {
                    if (!applyBookingPrefill(result)) {
                        return true;
                    }
                    advanceDeliveryStepIfApplicable();
                },
                error: function (error) {

                }
            });
        }

    }

  
  if (droppedToken && droppedToken.length) {
        rescheduleAlignBookingTool();
        $('#customer_token').val(droppedToken);
        $.ajax({
            url: 'https://api.v3.editsuits.com/store/booking/dropped/' + droppedToken,
            success: function (result) {
                applyBookingPrefill(result);
            },
            error: function (error) {
          
            }
        });

    }

}

function buildServices() {

    let allServiceIdInputs = document.querySelectorAll('.service_ids');

    $(allServiceIdInputs).each(async function (index, element) {

        if ($(element).attr('service-ids') !== undefined) {

            let service_ids = $(element).attr('service-ids').split(',').map(Number);

            for (let si of service_ids) {

                let p = '';


                let sd = await $.get(apiHost + '/services/get_services.json?service_ids[]=' + si);

                let showroomInfoElement = $('#showroom_info_' + sd[0].calendar_id);

                let popup = '';
                if (si === 52) {

                    popup = `<span id="pop_up_trigger"
                                data-image="https://cdn.shopify.com/s/files/1/0610/0543/0961/files/image.png?v=1675160303"
                                data-title="Video Appointment UK"
                                data-address="Do you have some questions or would you like to get a general idea first? <br/>Just book a virtual video appointment with one of our tailoring experts. Simply select a date and time that suits you, and we will send you a calendar invite with the video call details."
                                data-map=''
                                data-email=""
                                data-phone="" >i</span>`;

                } else {
                    popup = `<span id="pop_up_trigger"
                                data-image="${$(showroomInfoElement).attr('data-image')}"
                                data-title="${$(showroomInfoElement).attr('data-title')}"
                                data-address="${$(showroomInfoElement).attr('data-address')}"
                                data-map='${$(showroomInfoElement).attr('data-map')}'
                                data-email="${$(showroomInfoElement).attr('data-email')}"
                                data-phone="${$(showroomInfoElement).attr('data-phone')}" >i</span>`;
                }


                if (service_ids.length === 1) {

                    let labelText = $(element).closest('div').find('label').text();
                    labelText = translateServiceTitle(labelText);
                    p = `<p>${labelText.replace('(', '<br>(')}</p>`;
                } else {

                    let titleText = translateServiceTitle(sd[0].title);
                    p = `<p>${titleText.replace('-', '-<br>')}</p>`;
                }



                $(element).append(`<li class="bookingServiceSelector" calendar_id="${sd[0].calendar_id}" value="${sd[0].title}" data-id="${si}">${p}${popup}</li>`);


                window.serviceData[si] = sd;

            }


        }



    }).promise().done(function () {
        prefillTokenData();
        identifyEspixelCustomer();



    });



}

$('input[name="location"], select[name="location"]').change(function () {
    let value = $(this).val()

    let new_string = '';
    if (value == '' || value == 'epmty' || value === null) {
        $('.showroom-carousel__tabs .tab').removeClass('dissabled')
        $(this).removeClass('valueSuccess').addClass('withError')
    } else {
        if (!value.includes('Video')) {
            new_string = value.replace(' ', '_').toLowerCase();
        } else {
            new_string = '';
        }
        if ($('#step2 h2 small').length > 0) {
            $('#step2 h2 small').html(new_string)
        } else {
            $('#step2 h2').append(' <small>in ' + new_string + '</small>')
        }
        $('.showroom-carousel__tabs .tab').addClass('dissabled').removeClass('active')
        $('.showroom-carousel__tabs .tab').each(function (index, element) {
            if ($(element).attr('data-source').includes(new_string)) {
                $(element).removeClass('dissabled')
            }
        })
        $('.showroom-carousel__tabs .tab').not('.dissabled').first().find('a').click();
    }
})


function formatState(state) {
    if (!state.id) {
        return state.text;
    }
    let ifAvailability = '';
    if (state.element.dataset.availability) {
      ifAvailability = ' <span> ' + state.element.dataset.availability +  ' </span>';
    }
    var $state = $(
        '<span class="salesPersonOption"><img src="' + state.element.dataset.imgUrl + '" class="img-flag" /> <b>' + state.text + '</b></span>'
    );
    return $state;
};

function formatStateResult(state) {
    if (!state.id) {
        return state.text;
    }
    let ifAvailability = '';
    if (state.element.dataset.availability) {
      ifAvailability = ' <span> ' + state.element.dataset.availability +  ' </span>';
    }
    var $state = $(
        '<span class="salesPersonOption"><img src="' + state.element.dataset.imgUrl + '" class="img-flag" /> <b>' + state.text + ifAvailability + '</b></span>'
    );
    return $state;
};

$('.selector select').select2({
    dropdownCssClass: 'salesPerson',
    minimumResultsForSearch: -1,
    templateResult: formatStateResult,
    templateSelection: formatState,
    selectionCssClass: 'salesPerson'
});
$("select.form-item").select2({
    minimumResultsForSearch: -1
});

normalizeAcquisitionChannelOptions();

async function autoCapitalize() {

    var firstName = $('[name="first-name"]').val();
    firstName = firstName.charAt(0).toUpperCase() + firstName.slice(1);
    $('[name="first-name"]').val(firstName);

    var lastName = $('[name="last-name"]').val();
    lastName = lastName.charAt(0).toUpperCase() + lastName.slice(1);
    $('[name="last-name"]').val(lastName);

  
}

// -------------------------------------
async function validatePhone() {

  

}
async function checkInputs(block) {

    block.closest('.booking-page__steps').find('.form-item').each(function (index, element) {
        if ($(this).is(':visible')) {
            if ($(element).val() == '' || $(element).val() == 'empty') {
                $(element).addClass('withError')
            }
        }
    })
    if (/\d/.test($('[name="first-name"]').val()) && !$('[name="first-name"]').hasClass('withError')) {
        $('[name="first-name"]').addClass('withError')
    }
    if (/\d/.test($('[name="last-name"]').val()) && !$('[name="last-name"]').hasClass('withError')) {
        $('[name="last-name"]').addClass('withError')
    }
    if ($('[name="email"]').val().indexOf('@') < 0 || $('[name="email"]').val().indexOf('.') < 0 && !$('[name="email"]').hasClass('withError')) {
        $('[name="email"]').addClass('withError')
    }

    if ($(block).attr('data-target') == '#step3') {
        if ($('input[name="service_id"]').val() == '') {
            $('#step2 .dropdawn').addClass('withError')
        }
    }
}

function setLocation(loc = false) {

    // Check both select and hidden input
    let selectVal = $('select[name="location"]').val();
    let inputVal = $('input[name="location"]').val();
    
    if (selectVal != '' || inputVal != '' || loc) {
        var location = loc || selectVal || inputVal;
        
        $('.callendar_id_dropped').val(calendarIds[location]);
        $('#salesLoc').val(location);
        
        $('.service_group').each(function () {
            let cityAttr = $(this).attr('data-city');
            if (cityAttr != location) {
                $(this).hide()
            } else {
                $(this).fadeIn()
            }
        })
    }


}

function isAppointmentInPast(appointment) {
 
   // Convert appointment.day ("DD/MM/YYYY") and appointment.start ("HH:mm:ss")
  // into an ISO string. Since the appointment is in February (GMT), appending "Z" is fine.
  const [day, month, year] = appointment.day.split('/');
  // Ensure day and month have two digits
  const dayPadded = day.padStart(2, '0');
  const monthPadded = month.padStart(2, '0');
  const appointmentISO = `${year}-${monthPadded}-${dayPadded}T${appointment.start}Z`;
  const appointmentDate = new Date(appointmentISO);

  // Get the current date/time in London in an unambiguous ISO-like format.
  // The Swedish locale (sv-SE) returns "YYYY-MM-DD HH:mm:ss".
  const nowLondonStr = new Date().toLocaleString("sv-SE", { timeZone: "Europe/London" });
  // Convert to ISO format: "YYYY-MM-DDTHH:mm:ss"
  const nowLondonISO = nowLondonStr.replace(" ", "T");
  // Since in February London is on GMT (UTC+0), we can append "Z" to treat it as UTC.
  const nowLondon = new Date(nowLondonISO + "Z");

  return appointmentDate < nowLondon;
  
}


function rescheduleAppointment(id) {
    var url = apiHost + '/appointments/reschedule.json?token=' + id;
    $.get(url, function (data) {

                // Token-based redirect: Singapore appointments should always be viewed on the /en-sg/ locale.
                if (data.calendar && data.calendar.name && data.calendar.name.includes('Singapore') && !window.location.pathname.includes('/en-sg/')) {
                    window.location.href = window.location.origin + '/en-sg' + window.location.pathname + window.location.search + window.location.hash;
                    return;
                }

                // Reset token confirmation state before applying conditional layout.
                $('#tokenConfirmation').removeClass('is-expired');
                $('#tokenConfirmation button').prop('disabled', false);
                $('.cannotBeCancelled').hide();

        if (isAppointmentInPast(data.appointment)) {

           $('#tokenConfirmation button').prop('disabled', true);
                    $('#tokenConfirmation').addClass('is-expired');
          $('.cannotBeCancelled').show();
          
        }
      
        if (data.appointment.deleted_at !== null) {

            $('.booking-page__steps').hide()
            $('input[name="first-name"]').val(data.contact.first_name).change()
            $('input[name="last-name"]').val(data.contact.last_name).change()
            $('input[name="email"]').val(data.contact.email).change()
            $('#phone_formatted').val(data.contact.phone.trim().replace(' ', '')).change()
            $('input[name="service_id"]').val(data.service.id).change();

            var iti = window.intlTelInputGlobals.getInstance(document.querySelector("#phone"));
            iti.setNumber(data.contact.phone.trim().replace(' ', ''));
            $('#phone').change();
            let city = '';
            let calendarId = data.calendar.id;
            $('.tab[calendar_id="' + calendarId + '"] a').click();
            if (data.calendar.name.includes('London')) city = 'London';
            if (data.calendar.name.includes('Birmingham')) city = 'Birmingham';
            if (data.calendar.name.includes('Manchester')) city = 'Manchester';
            if (data.calendar.name.includes('Leeds')) city = 'Leeds';
            if (data.calendar.name.includes('Liverpool')) city = 'Liverpool';
            if (data.calendar.name.includes('Singapore')) city = 'Singapore';
             if (data.calendar.name.includes('Zurich') || data.calendar.name.includes('Zürich')) city = 'Zürich';
            if (data.calendar.name.includes('Virtual')) city = 'Video appointment - UK';
            $('select#salesLocation').val(city).trigger('change');
            $('#step1').fadeIn()

        } else {
            var service = data.service.title;

            $('#appointmentId').val(data.appointment.id);

            service = service.split(' - ')
            var translatedServiceName = translateAppointmentType(service[0]);
            $('.service').html(`<strong>${window.bookingTranslations.form.service} </strong><i>${translatedServiceName}</i>`)
            $('.location').html(`<strong>${window.bookingTranslations.form.location} </strong><i>${service[1]}</i>`)

            let city = '';
            let calendarId = data.calendar.id;
            $('.tab[calendar_id="' + calendarId + '"] a').click();
            if (data.calendar.name.includes('London')) city = 'London';
            if (data.calendar.name.includes('Birmingham')) city = 'Birmingham';
            if (data.calendar.name.includes('Manchester')) city = 'Manchester';
            if (data.calendar.name.includes('Leeds')) city = 'Leeds';
            if (data.calendar.name.includes('Liverpool')) city = 'Liverpool';
            if (data.calendar.name.includes('Singapore')) city = 'Singapore';
             if (data.calendar.name.includes('Zurich') || data.calendar.name.includes('Zürich')) city = 'Zürich';
            if (data.calendar.name.includes('Virtual')) city = 'Video appointment - UK';

            $('.service_group').hide()
            $('.service_group[data-city="' + city + '"]').show()
         
            $('select#salesLocation').val(city).trigger('change');

            $('input[name="first-name"]').val(data.contact.first_name).change()
            $('input[name="last-name"]').val(data.contact.last_name).change()
            $('input[name="email"]').val(data.contact.email).change()
            $('#phone_formatted').val(data.contact.phone.trim().replace(' ', '')).change()
            $('input[name="service_id"]').val(data.service.id).change();

            var iti = window.intlTelInputGlobals.getInstance(document.querySelector("#phone"));
            iti.setNumber(data.contact.phone.trim().replace(' ', ''));
            $('#phone').change();
            var dateParts = data.appointment.day.split("/");
            var new_date = dateParts[1] + '/' + dateParts[0] + '/' + dateParts[2];
            var date = new Date(new_date);
            var day = date.getDate(),

                year = date.getFullYear();
            var days = window.bookingTranslations.calendar.days;
            var monthNames = window.bookingTranslations.calendar.months;

        
          if (data.appointment.assignee_id !== 0 && data.appointment.assignee_id !== null) {

            let salesRepImg = data.appointment.assignee_photo_url;
            
            let salesRepName = data.appointment.assignee_name.split(' ')[0];
            if (data.appointment.assignee_name.split(' ').length > 2) {
              salesRepName = data.appointment.assignee_name.split(' ')[0] + ' ' +  data.appointment.assignee_name.split(' ')[1];
            }
            $('.salesRepSelectorSelected').html(`<strong style="padding-right: 50px">${window.bookingTranslations.form.tailoringAdvisor}</strong> <span class="salesPersonOptionSelected"> <img src="${salesRepImg}"/> <b>${salesRepName}</b></span> `);
  
          } else {
            $('.salesRepSelectorSelected').hide();
          }
     
         
          $('.date .date_bl').html(days[date.getDay()] + ', ' + day + ' ' + monthNames[date.getMonth()] + ' ' + year);
            $('.date .time').html(data.appointment.start.slice(0, -3) + ' - ' + data.appointment.end.slice(0, -3));
            
            $('.reason_close buttom').attr('data-appointment-id', data.appointment.token)

        }
    })
}

async function customerDetails(param) {

  let email =  $('input[name="email"]').val();

  // No email yet (or lookup failed): treat as a new customer instead of calling isRepeat/ (404 + uncaught rejection)
  let repeat = {};
  if (email && email.trim()) {
    try { repeat = await $.get('https://api.v3.editsuits.com/customer/isRepeat/' + encodeURIComponent(email.trim())) || {}; } catch (e) { repeat = {}; }
  }

  if (repeat.acquisition_channel && repeat.acquisition_channel.length) {
        const decodedAcquisitionChannel = decodeHtmlEntitiesDeep(repeat.acquisition_channel);
        $('#acquisition_channel').val(decodedAcquisitionChannel || repeat.acquisition_channel);
    $('.acquisitionChannelHolder').hide();
  }

  return param ? repeat[param] : repeat;
  

  
}

async function checkAndAdvanceToAvailableMonth(serviceId, startDate) {
    const maxMonthsToCheck = 6; // Don't check more than 6 months ahead
    let currentCheckDate = new Date(startDate);
    let monthsChecked = 0;
    
    while (monthsChecked < maxMonthsToCheck) {
        const year = currentCheckDate.getFullYear();
        const month = currentCheckDate.getMonth() + 1;
        
        try {
            const result = await getDays(serviceId, year, month, false);
            
            // Check if there are any open days in this month that will actually be displayed
            if (result && result.open_days_with_colors) {
                let hasVisibleDays = false;
                let appointmentType = resolveAppointmentType(window.serviceData[serviceId][0].title);
                let daysDefault = appointmentType === 'browsing' ? 56 : 42;
                let currentDate = new Date();
                let fourWeeksFromNow = new Date();
                fourWeeksFromNow.setDate(currentDate.getDate() + daysDefault);
                
                for (let day_full in result.open_days_with_colors) {
                    let targetDate = new Date(day_full);
                    
                    // Apply the same 4-week filter as getDays
                    if ((targetDate > fourWeeksFromNow) && onlyShowFourWeeks) {
                        continue;
                    }
                    
                    // If we get here, this day would be visible
                    hasVisibleDays = true;
                    break;
                }
                
                if (hasVisibleDays) {
                    // Found a month with available days that will be displayed
                    // If it's not the starting month, advance the datepicker
                    if (monthsChecked > 0) {
                        $('#datepicker').datepicker('setDate', new Date(year, month - 1, 1));
                        $('#datepicker').datepicker('refresh');
                    }
                    return;
                }
            }
        } catch (error) {
            console.error('Error checking month availability:', error);
            return;
        }
        
        // Move to next month
        // Set to first of month to avoid month-skipping (e.g., Jan 31 + 1 month = Mar 3)
        currentCheckDate.setDate(1);
        currentCheckDate.setMonth(currentCheckDate.getMonth() + 1);
        monthsChecked++;
    }
    
    // If we get here, no available months found in the range
    console.warn('No available appointments found in the next', maxMonthsToCheck, 'months');
}

// Flag to prevent onUpdateDatepicker from calling getDays when switching services
let isLoadingService = false;

function clearCalendarColors() {
  $('.ui-datepicker-calendar a').css('background-color', '');
  $('.ui-datepicker-calendar td').removeClass('clickable');
}

async function getDays(serv_id, year, month, skipUsers = false) {
    let selectedSalesPerson = $('#salesPerson').val();

    let salesPersonPart = '';
    if (+selectedSalesPerson > 0) {
        salesPersonPart = '&user_id=' + selectedSalesPerson;
    }

  let salesPersonId = urlParams.get('book_with');
  // remove selector
  if (!(window.location.href.includes('phone') || window.location.href.includes('deliv') || window.location.href.includes('measure') || await customerDetails('repeat')) && !salesPersonId) {
    skipUsers = true;
    $('.salesRepSelector').hide();
    $('.salesRepSelectorSelected').hide();
  }

  let apptIdPart = '';
  if ($('#appointmentId').val().length) {
    apptIdPart = '&appointment_id=' + $('#appointmentId').val();
  }
  
  
    var url = apiHost + '/appointments/get_days.json?year=' + year + '&month=' + month + '&service_id=' + serv_id + '&user_email=tim%40editsuits.com' + salesPersonPart + apptIdPart;
    return $.get(url, async function (data) {
        $('.callendar_id').val(data.id)

        // Clear calendar colors right before applying new ones
        clearCalendarColors();
      
        for (var day_full in data.open_days_with_colors) {

            let appointmentType = resolveAppointmentType(window.serviceData[serv_id][0].title);

            let daysDefault = 42;

            if (appointmentType && appointmentType === 'browsing') daysDefault = 56;
          
            let targetDate = new Date(day_full);
            let currentDate = new Date();
            let fourWeeksFromNow = new Date();
            fourWeeksFromNow.setDate(currentDate.getDate() + daysDefault); 

            if ((targetDate > fourWeeksFromNow) && onlyShowFourWeeks) {
              continue;
            }
          
            var dateArray = day_full.split("-");
            var month2 = parseInt(dateArray[1]) - 1, day = parseInt(dateArray[2]);
            $('.ui-datepicker-calendar a').each(function () {
                if ($(this).attr('data-date') == day) {
                    var td_m = parseInt($(this).parent('td').attr('data-month'))
                    if (td_m == month2) {
                        var bg = data.open_days_with_colors[day_full]
                        if (data.open_days_with_colors[day_full] == '#e27d09') {
                            bg = '#EBA739'
                        }
                        if (data.open_days_with_colors[day_full] == '#22964b') {
                            bg = '#7BD998'
                        }
                        $(this).css({
                            'background-color': bg
                        })
                        $(this).closest('td').addClass('clickable')
                    }
                }
            })
        }

        if (!skipUsers) {

          

       
            $('#salesPerson').empty();



          let firstDay = data.open_slots ? Object.keys(data.open_slots)[0] : null;
          if (firstDay && data.open_slots[firstDay] && !Object.keys(data.open_slots[firstDay]).length) firstDay = Object.keys(data.open_slots)[1];
         
          let firstTime = '';

          if (data.open_slots && data.open_slots[firstDay] && typeof data.open_slots[firstDay] === 'object')  {
            firstTime = Object.keys(data.open_slots[firstDay])[0];

          }
            let defaultOption = new Option(window.bookingTranslations.labels.noPreference, 0, false, false);
           defaultOption.dataset.imgUrl = 'https://cdn.shopify.com/s/files/1/0610/0543/0961/t/11/assets/no-pref.png?width=400';
           defaultOption.dataset.availability = `${window.bookingTranslations.labels.firstAvailability} ${formatDate(firstDay)}, ${firstTime}`; 
           $('#salesPerson').append(defaultOption);
          
      
            for (let users of data.available_users) {

         
                let firstAvailability = getFirstAvailability(users.id, users, false, year, month);

             
              
            }


           let salesPersonId = urlParams.get('book_with');
           let userExists = data.available_users.find((item) => item.id === +salesPersonId)
          if (salesPersonId) {
            if (userExists) {
              salesPersonId = +salesPersonId;
              setTimeout(function() {
                $('#salesPerson').val(salesPersonId).change();
                // Check if there are open slots for the selected salesperson
                checkSalesPersonAvailability(salesPersonId, userExists.name, serv_id, year, month);
              }, 2000);
            } else {
              // User is not in available list at all - show warning
              showSalesPersonUnavailableWarning(+salesPersonId);
            }
          }

        }

    });
}

function showDeliveryItemsWarning(deliveryBookingUrl) {
  let message = (window.bookingTranslations && window.bookingTranslations.booking && window.bookingTranslations.booking.hasDeliveryItemsWarning)
    || 'It looks like you have garments ready to be picked up. Please book a Delivery Appointment instead of a Purchase or Browsing appointment.';

  let bookNowText = (window.bookingTranslations && window.bookingTranslations.booking && window.bookingTranslations.booking.bookNow) || 'Book now';

  let buttons = [];
  if (deliveryBookingUrl) {
    buttons.push({
      text: bookNowText,
      "class": "shopify-challenge__button",
      click: function () {
        window.location.href = deliveryBookingUrl;
      }
    });
  } else {
    buttons.push({
      text: window.bookingTranslations && window.bookingTranslations.booking && window.bookingTranslations.booking.ok || "OK",
      "class": "shopify-challenge__button",
      click: function () {
        $(this).dialog("close");
      }
    });
  }

  $('#bookingError p').html(message);
  $("#bookingError").dialog({
    dialogClass: "esDialogBooking",
    modal: true,
    buttons: buttons
  });
}

function showSalesPersonUnavailableWarning(salesPersonId) {
  // Fetch the salesperson's name first
  $.ajax({
    url: 'https://api.v3.editsuits.com/store/salesPersonLocations/' + salesPersonId,
    success: function(result) {
      let salesPersonName = 'This person';
      if (result.status === 'success' && result.user && result.user.name) {
        salesPersonName = result.user.name;
      }
      
      let unavailableMessage = `Unfortunately, ${salesPersonName} isn't available at this location for the selected time period. You can continue by booking with another available person.`;
      
      $('#bookingError p').html(unavailableMessage);
      $("#bookingError").dialog({
        dialogClass: "esDialogBooking",
        modal: true,
        buttons: [
          {
            text: "OK",
            "class": "shopify-challenge__button",
            click: function() {
              $(this).dialog("close");
            }
          }
        ]
      });
    },
    error: function() {
      // If we can't get the name, still show a generic message
      let unavailableMessage = `Unfortunately, this person isn't available at this location for the selected time period. You can continue by booking with another available person.`;
      
      $('#bookingError p').html(unavailableMessage);
      $("#bookingError").dialog({
        dialogClass: "esDialogBooking",
        modal: true,
        buttons: [
          {
            text: "OK",
            "class": "shopify-challenge__button",
            click: function() {
              $(this).dialog("close");
            }
          }
        ]
      });
    }
  });
}

function checkSalesPersonAvailability(salesPersonId, salesPersonName, serviceId, year, month) {
  let apptIdPart = '';
  if ($('#appointmentId').val().length) {
    apptIdPart = '&appointment_id=' + $('#appointmentId').val();
  }

  var url = apiHost + '/appointments/get_days.json?year=' + year + '&month=' + month + '&service_id=' + serviceId + '&user_email=tim%40editsuits.com&user_id=' + salesPersonId + apptIdPart;

  $.get(url, function(data) {
    // Check if there are any open slots
    const hasOpenSlots = data.open_days_with_colors && Object.keys(data.open_days_with_colors).length > 0;
    
    if (!hasOpenSlots) {
      // Show popup warning
      let unavailableMessage = `Unfortunately, ${salesPersonName} isn't available at this location for the selected time period. You can continue by booking with another available person.`;
      
      $('#bookingError p').html(unavailableMessage);
      $("#bookingError").dialog({
        dialogClass: "esDialogBooking",
        modal: true,
        buttons: [
          {
            text: "OK",
            "class": "shopify-challenge__button",
            click: function() {
              $(this).dialog("close");
              // Reset to "No preference" (value 0)
              $('#salesPerson').val(0).trigger('change');
              // Refresh the calendar
              var currentDate = new Date();
              getDays(serviceId, currentDate.getFullYear(), currentDate.getMonth() + 1, false);
            }
          }
        ]
      });
    }
  });
}

function getFirstAvailability(userId = false, users = false, returnDate = false, year = false, month = false) {
   var date = new Date();

    let ifUserId = '';
    if (userId) {
      ifUserId = '&user_id=' + userId;
    }

    if (!month) month = (date.getMonth() + 1);
    if (!year) year = date.getFullYear();
    
    let url = 'https://book-new.editsuits.com/appointments/get_days.json?year=' + year + '&month=' + month + '&service_id=' + $('input[name="service_id"]').val() + ifUserId;

    $.get(url, function(data) {
      if (!Object.keys(data.open_slots).length) {
       
      } else {
        

        
        let firstDay = Object.keys(data.open_slots)[0];
        if (!Object.keys(data.open_slots[firstDay]).length) {
          firstDay = Object.keys(data.open_slots)[1];
        }
       
     let firstTime = '';

          if (data.open_slots && data.open_slots[firstDay] && typeof data.open_slots[firstDay] === 'object')  {
            firstTime = Object.keys(data.open_slots[firstDay])[0];

          }

        
        if (users) {

          let salesRepName = users.name.split(' ')[0];

           if (users.name.split(' ').length > 2) {
              salesRepName = users.name.split(' ')[0] + ' ' +  users.name.split(' ')[1];
            }
          let newOption = new Option(salesRepName, users.id, false, false);
          newOption.dataset.imgUrl = users.photo_url && users.photo_url.includes('cdn.shopify.com') ? users.photo_url.replace('https://book-new.editsuits.com/uploads/cache/', '') :  users.photo_url;
          newOption.dataset.availability = `${window.bookingTranslations.labels.firstAvailability} ${formatDate(firstDay)}, ${firstTime}`;
          $('#salesPerson').append(newOption);
        }              
        
      }
  });
}

function formatDate(dateString) {
  const date = new Date(dateString);
  
  // Check if the date is valid
  if (isNaN(date.getTime())) {
    return "Invalid Date";
  }

  const day = date.getDate();
  const suffix = getDaySuffix(day);
  const monthIndex = date.getMonth();
  
  const months = [
    "January", "February", "March", "April", "May", "June", 
    "July", "August", "September", "October", "November", "December"
  ];
  const month = months[monthIndex];

  return `${day}${suffix} ${month}`;
  
}

function getDaySuffix(day) {
  if (day >= 11 && day <= 13) {
    return "th";
  }
  switch (day % 10) {
    case 1: return "st";
    case 2: return "nd";
    case 3: return "rd";
    default: return "th";
  }
}


function getTime(serv_id, year, month, day) {

    let selectedSalesPerson = $('#salesPerson').val();

    let salesPersonPart = '';
    if (+selectedSalesPerson > 0) {
        salesPersonPart = '&user_id=' + selectedSalesPerson;
    }

    let apptIdPart = '';
  if ($('#appointmentId').val().length) {
    apptIdPart = '&appointment_id=' + $('#appointmentId').val();
  }

    var url = apiHost + '/appointments/get_slots.json?year=' + year + '&month=' + month + '&day=' + day + '&service_id=' + serv_id + salesPersonPart + apptIdPart;
    $.get(url, function (data) {


const formattedDate = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
       $('.time-slots').html('');

      var date = new Date(formattedDate),
                    date_day = date.getDate(),
                    date_year = date.getFullYear();
                var days_name = window.bookingTranslations.calendar.days;
                var monthNames = window.bookingTranslations.calendar.months;
                $('.time-heading h5').html(days_name[date.getDay()] + ', ' + date_day + ' ' + monthNames[date.getMonth()] + ' ' + date_year)
        if (!data.open_slots[formattedDate]) {
           var no_slots = `<div class='noSlots'>${window.bookingTranslations.availability.notAvailableOnThisDay}</div>`;
          $('.time-slots').html(no_slots)
        }
        for (var days in data.open_slots) {
            let duration = data.duration;
            var dateArray = days.split("-");
            if (dateArray[0] == year && dateArray[1] == month && dateArray[2] == day) {
               
                
                var time_slots = '<ul>';
                for (let i in data.open_slots[days]) {
                    if (data.open_slots[days][i] > 0) {

                        var target = new Date("1970-01-01T" + i);
                        target.setMinutes(target.getMinutes() + duration);
                        let endMinutes = 0;
                        if (target.getMinutes() === 0) {
                            endMinutes = '00';
                        } else {
                            endMinutes = target.getMinutes();
                        }
                        var end = target.getHours() + ':' + endMinutes;

                      let exclude = false;
                      let availableSlots = data.open_slots[days][i];
                      let availableSiblingSlots = 0;
                      

                        if (i.substr(-3) === ":00") {

                            availableSiblingSlots = data.open_slots[days][i.replace(':00', ':30')];
                          
                            if (availableSlots < availableSiblingSlots) exclude = true;
                          
                        } else {


                          availableSiblingSlots = data.open_slots[days][i.replace(':30', ':00')];
                          
                          if (availableSlots < availableSiblingSlots) exclude = true;

                          
                        }

                       
                        if (!exclude || (window.location.href.includes('phone') || window.location.href.includes('deliv'))) time_slots += '<li>' + i + ' - ' + end + '</li>';
                    }
                }
                time_slots += '</ul>';
                $('.time-slots').html(time_slots)
            }
        }
    });
}

// -------------------------

function clearAppointmentData() {

    $('#cancelation_reason').val('');
    $('#appointmentId').val('');
    $('input[name="first-name"]').val('').change();
    $('input[name="last-name"]').val('').change();
    $('input[name="email"]').val('').change();
    $('input[name="phone"]').val('').change();
    $('#phone_formatted').val('').change();

}

function cancelAppointment() {

    let reason = $('#cancel_reason').val();
    let reason_other = $('#cancel_reason_other').val();
    let appointmentId = $('#appointmentId').val();
    let data = {
        reason: reason,
        reason_other: reason_other,
        id: appointmentId
    }

    $('.appointmentCancelled').each(function () {
        $(this).find('.h2').text(window.bookingTranslations.booking.appointmentCancelledTitle);
        $(this).find('.h1').text(window.bookingTranslations.booking.appointmentCancelledHeading);
    });

    $.ajax({
        url: 'https://api.v3.editsuits.com/store/booking/cancel',
        type: 'POST',
        data: data,
        success: function () {
            $('#appointmentId').attr('last', appointmentId);
            clearAppointmentData();
        },
        error: function (error) {
        
        }
    });

}

function initializeCalendar() {

    let monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    var date = $('#datepicker').datepicker('getDate'),
        month = date.getMonth() + 1,
        year = date.getFullYear();
    var originalMonth = (parseInt(monthNames.indexOf($('.ui-datepicker-month').text())) + 1);
    if (originalMonth !== month) {
        $('#datepicker').datepicker("setDate", originalMonth + "/01/" + year);
    }
    if ($('input[name="service_id"]').val().length > 1) {
        let skipUsers = false;
        if ($('#salesPerson') && $('#salesPerson').val() && $('#salesPerson').val().length > 1) {
          skipUsers = true;
        }
        getDays($('input[name="service_id"]').val(), year, month, skipUsers)
    }
    $('#datepicker').datepicker("refresh");
}

$('.booking-page__steps button').on('click', function () {
    var block = $(this).attr('data-target');

    if (block === '#confirm-other') {

        if ($('#cancel_reason_other').val().length < 3) {

            $('#other_details').addClass('withError');
            return;
        } else {

            $('#other_details').removeClass('withError');
            $('.showroom-carousel__tabs .tab').removeClass('dissabled');
            $('p.error').hide();
            $('.booking-page__steps').hide()
            $('#step14').fadeIn();
            cancelAppointment();
            return;
        }

    }

    if ($(this).hasClass('button') && !$(this).hasClass('back')) {
        if (block === '#step1') {
            $('input').removeClass('withError');
        } else {
            checkInputs($(this));
        }
        if ($(this).closest('.booking-page__steps').find('.withError').length > 0) {

            return false
        }
    }
    if ($('#salesLocation').length) {
    setLocation();
    } else {
      setLocation('Singapore');
    }

    /* send to calendar for phone booking modify */

    if (block == '#step2' && window.location.href.includes('phone-book') && urlParams.get('token') !== null) {
        $('p.error').hide();
        $('.booking-page__steps').hide()
        initializeCalendar();
        $('#step3 .button.back').hide();
        $('#step3').fadeIn();
     
        alignBookingTool();

        return;
    }

   if (block == '#step2') {
        sendDatalayerEvent('Lead Next Step', false, false);
        sendFacebookSSE('Lead Next Step', false, false);
        $('#salesPerson').val('');
   }

    /* back to calendar view */

    if (block == '#step3') {
        initializeCalendar();

    }

    if (block == '#step_num') {
        $('p.error').show();
        return false;
    }

    if (parseInt(block.replace('#step', '')) > 7 && parseInt(block.replace('#step', '')) !== 15) {

        cancelAppointment();

        $('.showroom-carousel__tabs .tab').removeClass('dissabled');
    }
    if (parseInt(block.replace('#step', '')) > 7 && parseInt(block.replace('#step', '')) === 15) {
        $('.showroom-carousel__tabs .tab').removeClass('dissabled');
    }
    if (parseInt(block.replace('#step', '')) > 8) {
        $('.showroom-carousel__tabs .tab').removeClass('dissabled');
    }
    $('p.error').hide();
    $('.booking-page__steps').hide()

    $(block).fadeIn();
  
    alignBookingTool();
})

$('.keep_booking').on('click', function (e) {
    e.preventDefault();
    $('.booking-page__steps').hide()
    $('#step6').fadeIn();

});
$('.booking-page__steps #phone').change(async () => {
    validatePhone();


    $('#phone_formatted').val($('.iti__selected-dial-code').text() + $('[name="phone"]').val());
})
$('.booking-page__steps input, .booking-page__steps select').change(function () {
    const fieldName = $(this).attr('name');
    if (fieldName === 'email' || fieldName === 'first-name' || fieldName === 'last-name') {
        identifyEspixelCustomer();
    }
    if ($(this).val() != '' && $(this).val() != 'epmty') {
        $(this).removeClass('withError').addClass('valueSuccess');
        $('#phone_formatted').removeClass('withError');
    } else {
        $(this).removeClass('valueSuccess').addClass('withError');
    }
})
$(document).on('change', '.reasonOther', function () {
    $('#cancel_reason_other').val($(this).val());
});
$('.booking-grid__item .cancel_reason ul li').on('click', function () {
    $('.booking-grid__item .cancel_reason ul li').removeClass('active')
    $(this).addClass('active')
    var block = $(this).attr('data-step');
    // Use data-value (English) for server, not displayed text (which may be German)
    var reasonValue = $(this).attr('data-value') || $(this).text();
    $('#cancel_reason').val(reasonValue);
    $('.cancelation .button_group button').attr('data-target', block);
     $('.cancelation .button_group button').trigger('click');
})

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

function sendFacebookSSE(event, type = false, validateType = false) {

  
 try {

    if (window.location.href.includes('phone') || window.location.href.includes('deliv') || window.location.href.includes('alteration')) {
      return false;
    }

    if (!type) {
      type = $('h4.service').find('i').text();
    }
    let appointmentType = resolveAppointmentType(type);

    if (validateType && appointmentType !== 'purchase') return false;

    const fbpCookie = getCookie('_fbp');
    const fbcCookie = getCookie('_fbc');

    let data = {
      email: $('input[name="email"]').val(),
      fbp: fbpCookie,
      fbc: fbcCookie,
      event: event
    };

    $.ajax({
      type: "POST",
    url: 'https://api.v3.editsuits.com/tasks/fbServerEvent',
      data: data
    });

        trackEspixel(event, {
            email: data.email,
            fbp: fbpCookie,
            fbc: fbcCookie
        });

  } catch (error) {
    console.error('An error occurred in sendDatalayerEvent:', error);
    // Optionally, you can implement additional error handling here
  }
  
}

function sendDatalayerEvent(event, type = false, validateType = false) {
  
    if (!type) {
      type = $('h4.service').find('i').text();
    }
    let appointmentType = resolveAppointmentType(type);
   
    if (validateType && appointmentType !== 'browsing' && appointmentType !== 'purchase') return false;

    let fbpCookie = getCookie('_fbp');
    let fbcCookie = getCookie('_fbc');

   let selectedLocation = $('#salesLoc').val();
   let selectedCountry = 'UK';

   if (selectedLocation === 'Singapore') selectedCountry = 'Singapore';
   
    if (selectedLocation === 'Zürich') selectedCountry = 'CH';
  
    window.dataLayer.push({
      'event': event,
      'step_id': appointmentType,
      '_fbp': fbpCookie,
      '_fbc': fbcCookie,
      'email': $('#email').val(),
      'first_name': $('input[name="first-name"]').val(),
        'last_name': $('input[name="last-name"]').val(),
      'phone': $('#phone').val(),
      'city': selectedLocation,
      'country': selectedCountry
    });

        if (event !== 'Lead Next Step') {
            trackEspixel(event, {
                step_id: appointmentType,
                email: $('input[name="email"]').val(),
                first_name: $('input[name="first-name"]').val(),
                last_name: $('input[name="last-name"]').val(),
                phone: $('#phone').val(),
                city: selectedLocation,
                country: selectedCountry
            });
        }

  
  
  
}


$(function () {

    $("#datepicker").datepicker({
        dayNamesShort: window.bookingTranslations.calendar.dayNamesShort,
        monthNamesShort: window.bookingTranslations.calendar.monthNamesShort,
        firstDay: 1,
        showOtherMonths: true,
        selectOtherMonths: true,
        minDate: new Date(),
        onSelect: function () {
            var date = $(this).datepicker('getDate'),
                day = date.getDate(),
                month = date.getMonth() + 1,
                year = date.getFullYear();
            $('.booking-page__steps').hide()
            var days = window.bookingTranslations.calendar.days;
            var monthNames = window.bookingTranslations.calendar.months;
            $('.date .date_bl').html(' ' + days[date.getDay()] + ', ' + day + ' ' + monthNames[date.getMonth()] + ' ' + year)
            $('#step4').fadeIn();
            sendDatalayerEvent('Date Selected', false, true);
            getDays($('input[name="service_id"]').val(), year, month, true)
            getTime($('input[name="service_id"]').val(), year, month, day);
          updateSelectedSalesRep();
        },
        onChangeMonthYear: function (d_year, d_month) {
            var month = d_month,
                year = d_year;
            getDays($('input[name="service_id"]').val(), year, month, false)
            $('#step3').show();
        },
        onUpdateDatepicker: function () {
            // Don't reload if we're currently loading a new service
            if (isLoadingService) return;
            
            if ($('.time-heading h5').html() != '') {
                var date = $(this).datepicker('getDate'),
                    day = date.getDate(),
                    month = date.getMonth() + 1,
                    year = date.getFullYear();

                var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
                var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                $('.date .date_bl').html(' ' + days[date.getDay()] + ', ' + day + ' ' + monthNames[date.getMonth()] + ' ' + year)

                getDays($('input[name="service_id"]').val(), year, month, true)
                getTime($('input[name="service_id"]').val(), year, month, day);

            
            }
        },
    });

    $('.next-day').on("click", function (e) {
        e.preventDefault()
        var date = $('#datepicker').datepicker('getDate');
        date.setTime(date.getTime() + (1000 * 60 * 60 * 24))
        $('#datepicker').datepicker("setDate", date);
        alignBookingTool();
    });

    $('.prev-day').on("click", function (e) {
        e.preventDefault()
        var date = $('#datepicker').datepicker('getDate');
        date.setTime(date.getTime() - (1000 * 60 * 60 * 24))
        $('#datepicker').datepicker("setDate", date);
    });

    $(document).on('click', '.time-slots li', function () {
        $('.time-slots li').removeClass('active');
        $(this).addClass('active');
        $('.booking-page__steps').hide()
        $('.date .time').html(' ' + $(this).html())
        sendDatalayerEvent('Time Selected', false, true);
        $('#step5').fadeIn();
        alignBookingTool();
    })

    $('#step1 button').on('click', async function () {


        let activeBooking = await customerDetails('activeBooking');
       
      
        $('#phone_formatted').val($('.iti__selected-dial-code').text() + $('[name="phone"]').val());

       if (!activeBooking) {
        var data = {
            appointment_id: '',
            customer_token: $('#customer_token').val(),
            reschedule: false,
            appointment: {
                reschedule_link: $('#rescheduleLink').val(),
                day: '',
                start: '',
                end: '',
                calendar_id: $('input[name="callendar_id_dropped"]').val(),
                service_id: $('input[name="service_id"]').val(),
                skip_order_validation: true,
                calendar: {
                    date_format: '%d/%m/%Y',
                    time_format: '%H:%M'
                },
                contact_attributes: {
                    first_name: $('input[name="first-name"]').val(),
                    last_name: $('input[name="last-name"]').val(),
                    email: $('input[name="email"]').val(),
                    phone: reformatPhoneNumber($('#phone_formatted').val()),
                    location_alias: 'gb',
                    skip_full_address_validation: false,
                    skip_user_address_validation: true,
                },
                analytics_attributes: {
                    ip: $('#customerIP').val(),
                    referer: 'https://www.editsuits.com/',
                    source: '',
                    ga_client_id: 'undefined',
                    medium: '',
                    campaign: '',
                    content: ''
                }
            }
        };

        if ($('input[name="email"]').val().includes('batmanwith')) return false;
        if ($('input[name="email"]').val().includes('example@')) return false;
        if ($('input[name="email"]').val().includes('salman')) return false;
        
        if ($('input[name="email"]').val().includes('kamal@gmail.com')) return false;
        if ($('input[name="email"]').val().includes('kamalakar@gmail.com')) return false;
        if ($('input[name="email"]').val().includes('ajaysowmi')) return false;
        if ($('input[name="email"]').val().includes('rutvivivan')) return false;
        if ($('input[name="email"]').val().includes('dajaysowm')) return false;
    
        if ($('#phone_formatted').val().includes('7440517')) return false;
        if ($('#customerIP').val() === '82.13.180.122') return false;

        $.ajax({
            type: "POST",
            url: apiHost + '/appointments/dropped',
            data: data
        });

       }
    })


  function reformatPhoneNumber(phone) {
    let selectedLocation = $('#salesLoc').val();
    let selectedCountry = 'UK';
    if (selectedLocation === 'Singapore') selectedCountry = 'SG';
    if (selectedLocation === 'Zürich') selectedCountry = 'CH';
    
    
    // Normalize characters
    phone = phone.replace(/[\s\-\(\)]/g, '');

    // Fix duplicated or malformed country codes
    const corrections = {
        '+440': '+44',
        '+650': '+65',
        '+65+65': '+65',
        '+44+44': '+44',
        '+4444': '+44',
        '+6565': '+65'
    };

    for (const bad in corrections) {
        if (phone.includes(bad)) {
            phone = phone.replace(bad, corrections[bad]);
        }
    }

    // Replace leading 0 based on country
    if (phone.startsWith('0')) {
        if (selectedCountry === 'UK') {
            phone = phone.replace(/^0/, '+44');
        } else if (selectedCountry === 'SG') {
            phone = phone.replace(/^0/, '+65');
        }
    }

    return phone;
}


    $('#step5 button').on('click', function () {

        if ($(this).attr('data-target') !== '#step6') return false;

        var date = $('#datepicker').datepicker('getDate'),
            day = date.getDate(),
            month = date.getMonth() + 1,
            year = date.getFullYear(),
            start = $('.time-slots .active').html();
        if (parseInt(day) < 10) {
            day = '0' + day
        }
        if (parseInt(month) < 10) {
            month = '0' + month
        }
        let acquisitionChannel = '';

        if ($('#salesPersonName').val().length) {
        acquisitionChannel = $('#salesPersonName').val();  
        } else {
        acquisitionChannel =  $('#acquisition_channel').val();
        }

        // if (!acquisitionChannel.length && $('.acquisitionChannelHolder').length) {
        //   return false;
        // }
      
        var data = {
            appointment_id: '',
            customer_token: $('#customer_token').val(),
            reschedule: false,
            assignee_id: $('#salesPerson').val(),
            appointment: {
                acquisition_channel: acquisitionChannel,
                reschedule_link: $('#rescheduleLink').val(),
                day: day + '/' + month + '/' + year,
                start: start.split('-')[0].trim(),
                end: start.split('-')[1].trim(),
                calendar_id: $('input[name="callendar_id"]').val(),
                service_id: $('input[name="service_id"]').val(),
                assignee_id: $('#salesPerson').val(),
                skip_order_validation: true,
                calendar: {
                    date_format: '%d/%m/%Y',
                    time_format: '%H:%M'
                },
                contact_attributes: {
                    first_name: $('input[name="first-name"]').val(),
                    last_name: $('input[name="last-name"]').val(),
                    email: $('input[name="email"]').val(),
                    phone: reformatPhoneNumber($('#phone_formatted').val()),
                    location_alias: 'gb',
                    skip_full_address_validation: false,
                    skip_user_address_validation: true,
                },
                analytics_attributes: {
                    ip: $('#customerIP').val(),
                    referer: 'https://www.editsuits.com/',
                    source: '',
                    ga_client_id: 'undefined',
                    medium: '',
                    campaign: '',
                    content: ''
                }
            }
        };

        if ($('input[name="email"]').val().includes('batmanwith')) return false;
        if ($('input[name="email"]').val().includes('example@')) return false;
        if ($('input[name="email"]').val().includes('salman')) return false;
        if ($('input[name="email"]').val().includes('ajaysowmi')) return false;
        if ($('input[name="email"]').val().includes('rutvivivan')) return false;
        if ($('input[name="email"]').val().includes('dajaysowm')) return false;
    
        if ($('#phone_formatted').val().includes('7440517')) return false;
        if ($('#customerIP').val() === '82.13.180.122') return false;

        if ($('#appointmentId').val() !== '0' && $('#appointmentId').val() !== '' && $('#appointmentId').val() !== null && $('#appointmentId').val() !== undefined) {

            data.appointment_id = $('#appointmentId').val();
            data.customer_token = $('#customer_token').val();
            data.reschedule = true;

            let rescheduleData = {
                data: data,
                id: $('#appointmentId').val()
            }
            $.ajax({
                type: "POST",
                url: 'https://api.v3.editsuits.com/store/booking/reschedule',
                data: rescheduleData
            });

        } else {

          
            // create appointment 
            $.ajax({
                type: "POST",
                url: apiHost + '/appointments.json',
                data: data,
                success: function (result) {

                    if (result.id !== null && result.id !== undefined) {
                        $('#appointmentId').val(result.id);
                    }

                    // Self-confirm CTA for Purchase/Browsing appointments in UK stores only.
                    var serviceTitle = (window.serviceData[data.appointment.service_id] || [{}])[0].title || '';
                    var locationText = ($('.location i').text() || '').trim();
                    var appointmentType = resolveAppointmentType(serviceTitle);
                    var isPurchaseOrBrowsing = appointmentType === 'purchase' || appointmentType === 'browsing';
                    var selectedLocation = ($('#salesLoc').val() || $('#salesLocation').val() || '').toLowerCase();
                    var showroomText = (serviceTitle + ' ' + locationText + ' ' + selectedLocation + ' ' + window.location.pathname).toLowerCase();
                    var isNonUkShowroom = showroomText.includes('/en-sg') || showroomText.includes('/en-ch') || showroomText.includes('/de-ch') || showroomText.includes('singapore') || showroomText.includes('duxton') || showroomText.includes('zurich') || showroomText.includes('zürich');
                    var shouldShowSelfConfirm = isPurchaseOrBrowsing && !isNonUkShowroom;

                    if (shouldShowSelfConfirm && result.id && result.contact_id) {
                        $.ajax({
                            type: 'POST',
                            url: 'https://api.v3.editsuits.com/booking/getTokenById',
                            data: { id: result.id, contact_id: result.contact_id },
                            success: function (tokenResult) {
                                if (tokenResult.token) {
                                    $('#selfConfirmCta')
                                        .attr('href', 'https://account.editsuits.com/account/appointment/confirm/' + tokenResult.token)
                                        .show();
                                }
                            }
                        });
                    } else {
                        $('#selfConfirmCta').hide().attr('href', '#');
                    }

                    // Update Klaviyo language preference
                    if (data.appointment.contact_attributes.email) {
                        const language = window.location.pathname.includes('/de-ch') ? 'DE' : 'EN';
                        $.ajax({
                            type: "POST",
                            url: 'https://api.v3.editsuits.com/klaviyo/updateLanguage',
                            contentType: 'application/json',
                            data: JSON.stringify({
                                email: data.appointment.contact_attributes.email,
                                language: language
                            })
                        });
                    }

                    if (window.serviceData[data.appointment.service_id] !== undefined) {
                        let appointmentType = resolveAppointmentType(window.serviceData[data.appointment.service_id][0].title);
                        if (appointmentType === 'purchase') {
                            sendLuckyOrangeEvent('Booking completed - Purchase appt');
                            //window._vis_opt_queue = window._vis_opt_queue || [];
                            //  window._vis_opt_queue.push(function() {_vis_opt_goal_conversion(200);});
                      
	window._vis_opt_queue = window._vis_opt_queue || [];
	window._vis_opt_queue.push(function() {_vis_opt_goal_conversion(202);});
           
                        }

                      sendFacebookSSE('Purchase Appointment Booked', window.serviceData[data.appointment.service_id][0].title, true);
                      sendFacebookSSE('CompleteRegistration', window.serviceData[data.appointment.service_id][0].title, true);
                      sendDatalayerEvent('new_appointment', window.serviceData[data.appointment.service_id][0].title, true);
                      sendDatalayerEvent('Completed Registration', window.serviceData[data.appointment.service_id][0].title, true);
                             
                    }



                },
                error: function (result) {
                    if (result.responseJSON.appointment_exists !== undefined && result.responseJSON.appointment_exists !== null) {
                        if (Object.keys(result.responseJSON.appointment_exists).length > 0) {

                            // Create a temporary element to decode HTML entities
                            const decodeHtml = (html) => {
                                const txt = document.createElement('textarea');
                                txt.innerHTML = html;
                                return txt.value;
                            };

                            let appointmentExistsMessage = decodeHtml(window.bookingTranslations.booking.cannotCompleteActiveBookingHtml)
                                .replace('{{title}}', result.responseJSON.appointment_exists.existing_appointment.title)
                                .replace('{{date}}', result.responseJSON.appointment_exists.existing_appointment.date)
                                .replace('{{time}}', result.responseJSON.appointment_exists.existing_appointment.time)
                                .replace('{{location}}', result.responseJSON.appointment_exists.existing_appointment.location);


                            $('#bookingError p').html(appointmentExistsMessage);
                            $("#bookingError").dialog({
                                dialogClass: "esDialogBooking", modal: true, buttons: [
                                    {
                                        text: window.bookingTranslations.booking.resendConfirmation,
                                        "class": "shopify-challenge__button",
                                        click: function () {
                                            $(this).dialog("close");
                                            fetch(apiHost + '/appointments/resend_booking_email?token=' + result.responseJSON.appointment_exists.confirmation_link_token);
                                            $('#bookingError p').html(window.bookingTranslations.booking.confirmationResent);
                                            $("#bookingError").dialog({
                                                dialogClass: "esDialog", modal: true, buttons: [
                                                    {
                                                        text: window.bookingTranslations.booking.ok,
                                                        "class": "button shopify-challenge__button",
                                                        click: function () {
                                                            $(this).dialog("close");
                                                        }
                                                    }
                                                ]
                                            });
                                        }
                                    }
                                ]
                            });
                        }
                    } else {

                        $("#bookingError").dialog({
                            dialogClass: "esDialog", modal: true, buttons: [
                                {
                                    text: "Ok",
                                    "class": "button shopify-challenge__button",
                                    click: function () {
                                        $(this).dialog("close");
                                    }
                                }
                            ]
                        });

                    }
                    clearAppointmentData();
                    $('.booking-page__steps').hide();
                    $('input').removeClass('withError');
                    $('#step1').fadeIn();


                }
            });


        }

    })

    $('.dropdawn input').keypress(function (e) {
        e.preventDefault()
        return false;
    })

    $('.service_popup_body a').on('click', function (e) {
        e.preventDefault()
        $('.servis_popup').fadeOut();
    })

    $('.location_popup_body a').on('click', function (e) {
        e.preventDefault()
        $('.location_popup').fadeOut();
    })

    $('.cancel_popup_body a, .cancel_popup_body .button.button--secondary').on('click', function (e) {
        e.preventDefault()
        $('.cancel_popup').fadeOut();
    })

    $('.button.cancel').on('click', function () {
        $('.cancel_popup').fadeIn()
    })



    $(document).on('click', '.showroom-info address a', function (e) {
        e.preventDefault()
        var map = $(this).attr('href');

        // Create an iframe element
        var iframe = $('<iframe></iframe>');

        // Set the src attribute of the iframe to the map URL
        iframe.attr('src', map);

        // Set any additional attributes or styles for the iframe if needed
        // For example, you can set a width and height like this:
        iframe.attr('width', '100%');
        iframe.attr('height', '400px');

        $('.location_popup-info').html(iframe)
        $('.servis_popup').hide()
        $('.location_popup').fadeIn();
    })

    $(document).on('click', 'a.showMap', function (e) {
        e.preventDefault()
        var map = $(this).attr('href');

        var iframe = $('<iframe></iframe>');

        // Set the src attribute of the iframe to the map URL
        iframe.attr('src', map);
        iframe.attr('width', '100%');
        iframe.attr('height', '400px');
      
        $('.location_popup-info').html(iframe)
        $('.servis_popup').hide()
        $('.location_popup').fadeIn();
    })

    $(document).on('click', '.dropdawn ul li span', function () {
        var image = $(this).data('image'),
            title = $(this).data('title'),
            address = $(this).data('address'),
            map = $(this).data('map'),
            email = $(this).data('email'),
            phone = $(this).data('phone');

        $('.service_popup_body img').attr('src', image)
        $('.service_popup_body h4').html(title)
        let seeMap = '';
        if (map.length > 0) {
            const seeMapText = window.bookingTranslations?.labels?.seeMap || window.translations?.bookingTool?.labels?.seeMap || 'See map';
            seeMap = "<a href='" + map + "'>" + seeMapText + "</a>";
        }

        $('.service_popup_body address').html(address + ' ' + seeMap);
        $('.service_popup_body li:first-child').html(email)
        $('.service_popup_body li:last-child').html(phone)
        $('.servis_popup').fadeIn()
        return false;
    })

    $('.dropdawn i').click(function () {
        if ($(this).parent('.dropdawn').hasClass('selected')) {
            $(this).parent('.dropdawn').toggleClass('selected');
            $(this).parent('.dropdawn').find('ul').slideToggle()
        } else {
            $('.dropdawn.selected').find('ul').slideUp()
            $('.dropdawn.selected').removeClass('selected')
            $(this).parent('.dropdawn').toggleClass('selected');
            $(this).parent('.dropdawn').find('ul').slideToggle()
        }
    })

    $(document).on('click', '.dropdawn ul li', async function (e) {

        if ($(e.target).is('span')) {
            return false;
        }
        var location = $(this).closest('li').attr('value');
        let appointmentType = resolveAppointmentType(location);

        if (appointmentType === 'purchase' || appointmentType === 'browsing') {
            let repeatDetails = await customerDetails();
            if (repeatDetails && repeatDetails.deliveryItems) {
                showDeliveryItemsWarning(repeatDetails.deliveryBookingUrl);
                return false;
            }
        }

        $('#step2 .dropdawn').removeClass('withError')
        $('.dropdawn ul li').removeClass('active')
        $(this).addClass('active')

        let calendarId = $(this).closest('li').attr('calendar_id');

        // Update reschedule link based on appointment type
        if (appointmentType === 'purchase' || appointmentType === 'browsing') {
            $('#rescheduleLink').val($('#rescheduleBookingLink').val());
        }

        if (appointmentType === 'purchase' || appointmentType === 'browsing') {
            sendLuckyOrangeEvent('Booking tool use - Purchase appt selected');
            window.dataLayer.push({
                'event': 'appointment_selected',
                'appointment_type': appointmentType
            });
        }

        var location_arr = location.split(' - ')

        if (location_arr.length === 1) {
            location_arr.push(location_arr[0]);
        }

        var translatedServiceName = translateAppointmentType(location_arr[0]);
        $('.service').html('<strong>' + window.bookingTranslations.form.service + ' </strong> <i>' + translatedServiceName + '</i>')

        $('.location').html('<strong>' + window.bookingTranslations.form.location + ' </strong> <i>' + location_arr[1] + '</i>')

        $('.showroom-carousel__tabs .tab').addClass('dissabled').removeClass('active')
        $('.showroom-carousel__tabs .tab').each(function (index, element) {
            if ($(element).attr('calendar_id') === calendarId) {
                $(element).removeClass('dissabled').find('a').click()
                $(element).addClass('active')
            }
        })



        $('input[name="service_id"]').val($(this).closest('li').attr('data-id')).change()
        if ($('input[name="service_id"]').val() != '') {
            var date = new Date();
            // Set flag to prevent onUpdateDatepicker from interfering
            isLoadingService = true;
            
            // Use setTimeout to ensure datepicker is fully rendered
            setTimeout(async () => {
                try {
                    // Reset to current month before checking availability
                    $('#datepicker').datepicker("setDate", date);
                    $('#datepicker').datepicker("refresh");
                    // Check if current month has open days, if not advance to next month
                    await checkAndAdvanceToAvailableMonth($('input[name="service_id"]').val(), date);
                    
                    // After advancing (or not), ensure colors are loaded for the displayed month
                    const displayedDate = $('#datepicker').datepicker('getDate') || date;
                    await getDays($('input[name="service_id"]').val(), displayedDate.getFullYear(), displayedDate.getMonth() + 1, false);
                } finally {
                    isLoadingService = false;
                }
            }, 50);
            
            $('.booking-page__steps').hide()

      
        
          sendDatalayerEvent('Service Selected', location_arr[0], false);
          
            $('#step3').fadeIn()
        }
    })

    $('[href="#aligner"').on('click', function () {
        sendLuckyOrangeEvent('Booking tool use');
    });


    $(document).on('change', '#salesPerson', function (e) {

        // Get the displayed month/year from the datepicker UI, not the selected date
        let monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        let displayedMonth = monthNames.indexOf($('.ui-datepicker-month').text()) + 1;
        let displayedYear = parseInt($('.ui-datepicker-year').text());
        
        $('#datepicker').datepicker("refresh");
        getDays($('input[name="service_id"]').val(), displayedYear, displayedMonth, true)


    });


    $(document).on('click', '.open_sliding_booking, a[href="#showroom"]', function (e) {
        e.preventDefault();
        $('body').addClass('openBooking');

        alignBookingTool();
        sendLuckyOrangeEvent('Booking tool use');
    })

    $('.color_bg').on('click', function () {
        $('.servis_popup, .location_popup').hide()
    })

    $('.close_sliding_booking, #close_sliding').on('click', function (e) {
        e.preventDefault()
        $('body').removeClass('openBooking')
    })

    $(document).ready(function () {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        buildServices();


        const phoneInputField = document.querySelector("#phone");
        window.intlTelInput(phoneInputField, {
            utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
            separateDialCode: true,
            autoPlaceholder: false,
            formatOnDisplay: false,
            preferredCountries: ["gb", "sg"],
            excludeCountries: ["us"]
        });

        if (window.location.href.includes('en-sg')) {
            var iti = window.intlTelInputGlobals.getInstance(document.querySelector("#phone"));

            iti.setCountry('SG');
            $('a[href="#singapore_-__duxton_rd"]').click();
        } else if (window.location.href.includes('de-ch') || window.location.href.includes('en-ch')) {
            var iti = window.intlTelInputGlobals.getInstance(document.querySelector("#phone"));

            iti.setCountry('CH');
        }

    })

    $('.reset_all').on('click', function () {
        $('.cancel_reason li').removeClass('active')
    })



});

$(document).ajaxStart(function () {
    $('.preloader').css({ 'display': 'flex' })
})

$(document).ajaxStop(function () {
    $('.preloader').css({ 'display': 'none' })
})
